import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

export function TypeField() {
  const texts = useTexts()
  const options: {
    type: 'option'
    value: uui.domain.server.rm.MobileAppInteraction['type']
    label: string
    description: string
  }[] = [
    {
      type: 'option',
      value: 'NONE',
      label: texts.off,
      description: texts.offDescription,
    },
    {
      type: 'option',
      value: 'ASSISTED_TIME_OUT',
      label: texts.suggest,
      description: texts.suggestDescription,
    },
    {
      type: 'option',
      value: 'DRIVER_REQUIRED_FLOW',
      label: texts.require,
      description: texts.requireDescription,
    },
  ]

  return (
    <form.RadioGroup
      name="type"
      label={texts.mode}
      options={options}
      validateOn="blur change"
      testId="driver-assistance-form-type-field"
      radioGroupProps={{
        sx: { marginLeft: 1 },
      }}
    />
  )
}
